import { render } from "./ProdValor02.vue?vue&type=template&id=ddd3b8e0&scoped=true"
import script from "./ProdValor02.vue?vue&type=script&lang=js"
export * from "./ProdValor02.vue?vue&type=script&lang=js"

import "./ProdValor02.vue?vue&type=style&index=0&id=ddd3b8e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd3b8e0"]])

export default __exports__